import { Fragment, ReactElement } from 'react';
import PersonSipoNonResidentSearchPage from 'cancellations/pages/edit-person';
import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';

interface PersonSearchDeathNonResidentNotificationSharedProps {
  goBackUrl?: string;
  redirectUrl?: string;
  items?: BreadcrumbItem[];
}

const PersonSearchDeathNonResidentNotificationShared = ({
  goBackUrl = '',
  redirectUrl = '',
  items = [],
}: PersonSearchDeathNonResidentNotificationSharedProps): ReactElement => {
  return (
    <Fragment>
      <PersonSipoNonResidentSearchPage
        redirectUrl={redirectUrl}
        goBackUrl={goBackUrl}
        breadcrumbItems={items}
      />
    </Fragment>
  );
};

PersonSearchDeathNonResidentNotificationShared.displayName =
  'Research Death Non Resident Notifications Page component';

export default PersonSearchDeathNonResidentNotificationShared;
